export default __webpack_public_path__ + "static/media/Darkblade's Boots of the Dark Pact.f14f92be.jpg";